import { createReducer, on } from '@ngrx/store';
import * as fromPaymentActions from '../actions/payment.action';
export const featureKey = 'payment';

export interface State {
    paymentMethods: {
        data: Array<any>,
        isLoaded: Boolean
    };
    paymentSchemes: {
        data: Array<any>,
        isLoaded: Boolean
    };
    paymentSchemeDetails: {
        data: Array<any>,
        isLoaded: Boolean
    };
    paymentTerms: {
        data: Array<any>,
        isLoaded: Boolean
    };
    paymentTypes: {
        data: Array<any>,
        isLoaded: Boolean
    };
    selectedPaymentScheme: {
        data: Array<any>,
        isLoaded: Boolean
    };
    previewPaymentScheme: {
        data: Array<any>,
        isLoaded: Boolean
    };
    studentPaymentBalance: {
        data: Array<any>,
        isLoaded: Boolean
    };
    paymentList: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    paymentMethods: {
        data: [],
        isLoaded: false
    },
    paymentSchemes: {
        data: [],
        isLoaded: false
    },
    paymentSchemeDetails: {
        data: [],
        isLoaded: false
    },
    paymentTerms: {
        data: [],
        isLoaded: false
    },
    paymentTypes: {
        data: [],
        isLoaded: false
    },
    selectedPaymentScheme: {
        data: [],
        isLoaded: false
    },
    previewPaymentScheme: {
        data: [],
        isLoaded: false
    },
    studentPaymentBalance: {
        data: [],
        isLoaded: false
    },
    paymentList: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromPaymentActions.getPaymentMethodsSuccess, (state: State, props: any) => ({
        ...state,
        paymentMethods: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.getPaymentSchemesSuccess, (state: State, props: any) => ({
        ...state,
        paymentSchemes: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.getPaymentSchemeDetailsSuccess, (state: State, props: any) => ({
        ...state,
        paymentSchemeDetails: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.getPaymentTermsSuccess, (state: State, props: any) => ({
        ...state,
        paymentTerms: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.getPaymentTypesSuccess, (state: State, props: any) => ({
        ...state,
        paymentTypes: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.selectPaymentScheme, (state: State, props: any) => ({
        ...state,
        selectedPaymentScheme: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.previewPaymentSchemeSuccess, (state: State, props: any) => ({
        ...state,
        previewPaymentScheme: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.getStudentPaymentBalanceSuccess, (state: State, props: any) => ({
        ...state,
        studentPaymentBalance: { data: props.data, isLoaded: true },
    })),
    on(fromPaymentActions.getPaymentListSuccess, (state: State, props: any) => ({
        ...state,
        paymentList: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);